<template>
    <div class="popUpDialog">
      <el-dialog title="站点添加" :visible.sync="dialogShow" :show-close="false" :close-on-click-modal="false" ref="addDialogRef" >
         <div class="add_content">
           <!--<div class="flex title"><div>站点名称</div><div>站点地址</div></div>-->
           <div>
             <el-form :inline="true" :model="addSiteList" :rules="addSiteList.rules" ref="addsiteRef">
               <el-table :data="addSiteList.siteList">
                  <el-table-column label="站点名称">
                     <template slot-scope="scope">
                       <el-form-item :prop="'siteList.'+scope.$index+'.name'" :rules="addSiteList.rules.name">
                         <el-input placeholder="设置您的网站名称" v-model="scope.row.name"></el-input>
                       </el-form-item>
                     </template>
                  </el-table-column>
                  <el-table-column label="站点地址">
                     <template slot-scope="scope">
                       <el-form-item :prop="'siteList.'+scope.$index+'.host'" :rules="addSiteList.rules.host">
                         <el-input placeholder="请输入要添加的域名" v-model="scope.row.host"></el-input>
                       </el-form-item>
                     </template>
                  </el-table-column>
               </el-table>
             </el-form>
           </div>
         </div>
         <div class="addNewLine"><span @click="addNewLine">新增一行</span></div>
         <span slot="footer" class="dialog-footer">
           <el-button type="primary" @click="submitSite('addsiteRef')">确 定</el-button>
           <el-button @click="cancelBtn('addsiteRef')">取 消</el-button>
         </span>
      </el-dialog>
    </div>
</template>

<script>
    import {addSite} from '../api/api'
    export default {
      props:['dialogShow'],
      data(){
        return{
          addSiteList:{
            rules:{
              name:[
                {required:true,message:'请输入站点名称',trigger:'blur'},
                {pattern:/^(?!(\s+$))/,message:'输入站点名称'}
              ],
              host:[
                {required:true,message:'请输入站点地址',trigger:'blur'},
                {pattern:/([a-z0-9][a-z0-9\-]*?\.(?:com|cn|net|org|gov|info|la|cc|co)(?:\.(?:cn|jp))?)$/,message:'输入正确的站点地址'}
              ]
            },
            siteList:[{
              name:'',
              host:''
            }]
          }
        }
      },
      mounted(){
      },
      methods:{
        submitSite(formName){
          //新增站点
          this.$refs[formName].validate((valid)=>{
            if(valid){
              let addSiteData = {sites:this.addSiteList.siteList};
              addSite(addSiteData).then(refs=>{
                console.log(refs);
                if(refs.data.code==1){
                  this.$emit('submitSite');
                  this.$message({
                    type: 'success',
                    message:'站点添加成功'
                  });
                  this.addSiteList.siteList = [{
                    name:'',
                    host:''
                  }]
                }else{
                  this.$message({
                    type: 'error',
                    message:refs.data.message
                  })
                }
              }).catch(err=>{
                console.log(err);
                this.$message({
                  type: 'error',
                  message:'服务器有问题，请稍后再试'
                })
              })
            }else{
              console.log('error submit!');
              return false;
            }
          })
        },
        addNewLine(){
          //新增一行
          this.addSiteList.siteList.push({name:'',host:''});
        },
        cancelBtn(formName){
          this.$emit('closeAddDialog');
          this.$refs[formName].resetFields();
          // this.addSiteList.siteList=[{name:'', host:''}];
          this.addSiteList.siteList = [{
            name:'',
            host:''
          }]
        }
      }
    }
</script>

<style scoped lang="scss">
  .popUpDialog{
    .add_content{
      .title{
        text-align: left;
        height: 40px;
        line-height: 40px;
        padding-left:15px;
        background:#F1F5F8;
        margin-bottom: 15px;
        div{
          flex:1;
          font-size: 14px;
          color: #333333;
        }
      }
    }
    .addNewLine{
      padding:12px 0;
      border-bottom:1px solid #E9E9E9;
      span{
        font-size: 14px;
        color: #2F87FF;
        cursor: pointer;
      }
    }
  }
   .popUpDialog /deep/ .el-dialog__wrapper{
     .el-dialog{
       width:634px;
       .el-dialog__header{
         text-align: left;
         padding-left:24px;
         span{
           font-size: 18px;
           color: #000;
         }
       }
       .el-dialog__body{
         padding-left:24px;
         padding-bottom:15px;
         .el-table__header-wrapper{
           tr>th{
             padding:8px 0;
             background: #F1F5F8;
             div{
               font-size: 14px;
               color: #333333;
             }
           }
         }
         .el-form{
           .el-form-item{
             .el-input{
               width:270px;
             }
           }
         }
         .el-table__body-wrapper{
           height:260px;
           overflow-y: auto;
           .el-table__row{
              td{
                padding-bottom:0;
              }
           }
         }
       }
       .el-dialog__footer{
         text-align: center;
       }
     }
   }
</style>



// WEBPACK FOOTER //
// src/components/addSites.vue